/**
 * 空状态组件
 */

import React from 'react';
import { Empty } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

interface EmptyStateProps {
  description?: string;
  icon?: React.ReactNode;
  extra?: React.ReactNode;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  description = '暂无数据',
  icon = <ExclamationCircleOutlined style={{ fontSize: 48, color: '#d9d9d9' }} />,
  extra,
}) => {
  return (
    <Empty
      image={icon}
      description={description}
      style={{ padding: 40 }}
    >
      {extra}
    </Empty>
  );
};

export default EmptyState;
